export function toTitleCase(str?: string) {
  if (!str) return '';
  str = str.split('_').join(' ');
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}
export function camelToSentence(camelCaseString?: string): string {
  if (!camelCaseString) {
    return '';
  }
  // split the string at every capital letter
  const words = camelCaseString?.split(/(?=[A-Z])/);
  // capitalize the first word and join the rest with spaces
  const sentence =
    words[0][0].toUpperCase() +
    words[0].slice(1).toLowerCase() +
    ' ' +
    words
      .slice(1)
      .map((word) => word.toLowerCase())
      .join(' ');

  return sentence;
}
